import { createSelector } from 'reselect';
import { selectProductPricingFallBack } from '../fromState';

export default createSelector(
    [selectProductPricingFallBack],
    (productPricingFallBack) => !!productPricingFallBack.isError
);
